import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationProgress = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, label: 'Account Info', icon: 'User' },
    { number: 2, label: 'Fitness Profile', icon: '/assets/images/More_Than_Technology_logo-01-1769218379125.jpg' },
    { number: 3, label: 'Membership', icon: 'CreditCard' }
  ];

  return (
    <div className="mb-8 md:mb-12">
      <div className="flex items-center justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-muted -z-10" />
        <div 
          className="absolute top-5 left-0 h-0.5 bg-accent transition-smooth -z-10"
          style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
        />

        {steps?.map((step) => (
          <div key={step?.number} className="flex flex-col items-center gap-2">
            <div
              className={`
                flex items-center justify-center w-10 h-10 rounded-full border-2 transition-smooth
                ${currentStep >= step?.number
                  ? 'bg-accent border-accent text-accent-foreground'
                  : 'bg-card border-border text-muted-foreground'
                }
              `}
            >
              {currentStep > step?.number ? (
                <Icon name="Check" size={20} strokeWidth={2.5} />
              ) : (
                <Icon name={step?.icon} size={20} />
              )}
            </div>
            <span className={`text-xs md:text-sm caption font-medium ${
              currentStep >= step?.number ? 'text-foreground' : 'text-muted-foreground'
            }`}>
              {step?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegistrationProgress;